import type { PaletteMode, ThemeOptions } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import { toValidMuiColor } from "../utils/theme-color.utils";
import {
  DEFAULT_BRAND_COLOR,
  SEEDIT_DARK_SURFACES,
  SEEDIT_FONT_FAMILY,
  SEEDIT_FONT_FAMILY_MONO,
  SEEDIT_LIGHT_SURFACES,
  SEEDIT_SEMANTIC_COLORS
} from "./seedit-theme.tokens";

export function makeSeeditThemeOptions(
  colorMode: PaletteMode,
  brandColor: string = DEFAULT_BRAND_COLOR
): ThemeOptions {
  const primaryMain = toValidMuiColor(brandColor);
  const isDark = colorMode === "dark";
  const surfaces = isDark ? SEEDIT_DARK_SURFACES : SEEDIT_LIGHT_SURFACES;

  return {
    palette: {
      mode: colorMode,
      primary: { main: primaryMain },
      secondary: { main: grey[300] },
      info: { main: SEEDIT_SEMANTIC_COLORS.info },
      warning: { main: SEEDIT_SEMANTIC_COLORS.warning },
      background: { ...surfaces.background },
      text: { ...surfaces.text }
    },
    typography: {
      fontFamily: SEEDIT_FONT_FAMILY,
      h6: { fontWeight: 600 },
      body2: { fontWeight: 400 }
    },
    transitions: {
      duration: {
        shortest: 150,
        shorter: 200,
        short: 200
      }
    },
    components: {
      MuiButton: {
        defaultProps: { variant: "contained", disableElevation: true },
        styleOverrides: {
          root: {
            borderRadius: 6,
            fontWeight: 600,
            textTransform: "none",
            boxShadow: "none",
            textDecoration: "none",
            "&:hover": { boxShadow: "none", textDecoration: "none" }
          },
          contained: {
            boxShadow: "none",
            "&:hover": { boxShadow: "none" }
          },
          containedWarning: {
            backgroundColor: SEEDIT_SEMANTIC_COLORS.buttonWarning,
            "&:hover": { backgroundColor: "#9A4608" }
          },
          containedInfo: {
            "&:hover": { backgroundColor: "#2563EB" }
          }
        }
      },
      MuiDialog: { styleOverrides: { paper: { backgroundImage: "unset" } } },
      MuiTextField: { defaultProps: { variant: "standard" } },
      MuiCssBaseline: {
        styleOverrides: {
          code: { fontFamily: SEEDIT_FONT_FAMILY_MONO }
        }
      }
    }
  };
}
